// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"1a1ee1cc","14":"6d46c27c","257":"54511b40","324":"2a513a78","495":"e7808702","512":"e7736c86","522":"bade3958","571":"bade3958","672":"3c720f70","720":"fa4c6a8c","931":"7fca9241"}[chunkId] + ".chunk.css";
};